export default 'M6 2v20a2 2 0 0 1-4 0V2a2 2 0 0 1 4 0m15.41 18.59a2 2 0 1 1-2.82 2.82L7.17 12 18.6.59a2 2 0 1 1 2.8 2.81L12.83 12z';